import { Controller } from 'stimulus';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
class _class extends Controller {
  connect() {
    if (!this.hasButtonTarget) return;
    this.originalText = this.buttonTarget.innerText;
    this.successDuration = this.successDurationValue || 2000;
  }

  copy(event) {
    event.preventDefault();
    this.sourceTarget.select();
    document.execCommand('copy');
    this.copied();
  }

  copied() {
    if (!this.hasButtonTarget) return;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.buttonTarget.innerText = this.data.get('successContent');
    this.timeout = setTimeout(() => {
      this.buttonTarget.innerText = this.originalText;
    }, this.successDuration);
  }

}

_defineProperty(_class, "targets", ['button', 'source']);

_defineProperty(_class, "values", {
  successDuration: Number
});

export default _class;
//# sourceMappingURL=index.js.map
